var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67378",
    "data-name": "Group 67378",
    transform: "translate(-479 -498)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(479 498)",
    fill: "#2a865c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(487 506)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-plus-small",
    transform: "translate(371 390)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67430",
    "data-name": "Group 67430",
    transform: "translate(128 128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67429",
    "data-name": "Group 67429",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80489",
    "data-name": "Path 80489",
    d: "M142.667,134.667h-5.333v-5.333a1.333,1.333,0,1,0-2.667,0v5.333h-5.333a1.333,1.333,0,0,0,0,2.667h5.333v5.333a1.333,1.333,0,1,0,2.667,0v-5.333h5.333a1.333,1.333,0,1,0,0-2.667Z",
    transform: "translate(-128 -128)",
    fill: "#02fdb1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIco);
export default __webpack_public_path__ + "static/media/plus-ico.300286f0004656717da984e93a68e11e.svg";
export { ForwardRef as ReactComponent };